import React, { useEffect, useState, useContext } from "react";
import styles from "./FiltersComponents.module.css";
import fetchSpreadsheetData from "../../Services/companiesData";
import { GlobalStateContext } from "../../context/GlobalStateContext";

import { FilterDropdown } from "./FilterDropdown";

function FiltersComponent() {
  const { exchangeName } = useContext(GlobalStateContext);
  
  const [companyNames, setCompanyNames] = useState([]);
  const [companyCountries, setCompanyCountries] = useState([]);
  const [sectors, setSectors] = useState([]);
  useEffect(() => {
    async function getData() {
      try {
        const { companyNames, companyCountries, sectors } =
          await fetchSpreadsheetData(exchangeName);

        setCompanyNames(companyNames);
        setCompanyCountries(companyCountries);
        setSectors(sectors);

      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors
      }
    }

    getData();
  }, []);

  return (
    <>
      <div className={styles.filtersContainer}>
        <FilterDropdown 
          single_item="company"
          plural_items="companies"
          options={companyNames}
          filterType="companyNames"
        />
        <FilterDropdown 
          single_item="sector"
          plural_items="sectors"
          options={sectors}
          filterType="sectors"
        />
        {/* <FilterDropdown 
          single_item="country"
          plural_items="countries"
          options={companyCountries}
          filterType="companyCountries"
        /> */}
      </div>
    </>
  );
}

export default FiltersComponent;
